import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=6586f10c&scoped=true&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"
import style0 from "./credit.vue?vue&type=style&index=0&id=6586f10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586f10c",
  null
  
)

export default component.exports